module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), (_vm.user) ? _c('button', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('button', {
    on: {
      "click": _vm.loginGoogle
    }
  }, [_vm._v("Login Google")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/examples"
    }
  }, [_vm._v("Examples")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/firepad"
    }
  }, [_vm._v("Firepad")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/aviasim"
    }
  }, [_vm._v("AviaSim")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/building"
    }
  }, [_vm._v("Building")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60fda440"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive/Hello.vue
// module id = 302
// module chunks = 3